export const SITE_URL = "https://www.shivamurtihealingarts.com";
export const ORG_NAME = "Shiva Murti Sacred Healing Arts";
export const ORG_EMAIL = "info@shivamurtihealingarts.com";
export const ORG_SAME_AS = ["https://www.instagram.com/shiva_murti_healing_arts"];
export const JOHNNY_SAME_AS = ["https://www.instagram.com/mrjohnnycan"];
export const GHL_SOCIAL_FORM_URL =
  "https://api.leadconnectorhq.com/widget/form/6bmvjXP6XWQ9TjT80ny0";

export const PAGES = {
  "/": {
    name: "Home",
    title: "Shiva Murti Healing Vancouver · Balinese Lineage Healing",
    description:
      "Shiva Murti is a Balinese sacred healing lineage from High Priest Ratu Nabe. Receive healing in Vancouver or online, or train to become a practitioner.",
  },
  "/receive": {
    name: "Receive",
    title: "Shiva Murti Healing Sessions · Vancouver & Online",
    description:
      "Receive Shiva Murti, a Balinese energy healing ceremony for cleansing, blessing and restoration. In person in Vancouver or worldwide by video.",
  },
  "/become": {
    name: "Become",
    title: "Learn Shiva Murti · Practitioner Training & Initiation",
    description:
      "Train in the Shiva Murti lineage. Initiation, ceremony and practitioner certification with Johnny Cantiveros, one of four authorized lineage teachers.",
  },
  "/events": {
    name: "Events",
    title: "Shiva Murti Events & Healing Ceremonies · Vancouver",
    description:
      "Upcoming Shiva Murti healing ceremonies, introductions and trainings in Vancouver and online.",
  },
  "/lineage": {
    name: "Lineage",
    title: "The Shiva Murti Lineage · Ratu Nabe, Bali",
    description:
      "The origin of Shiva Murti (also spelled Siwa Murti), a Balinese healing lineage created by High Priest Ratu Nabe and passed on through initiation.",
  },
  "/contact": {
    name: "Contact",
    title: "Contact Shiva Murti Sacred Healing Arts · Vancouver",
    description:
      "Book a Shiva Murti session or ask about training. Based in Vancouver, working worldwide by video.",
  },
};

export const canonicalUrl = (path) => `${SITE_URL}${path === "/" ? "/" : path}`;
